import { render, staticRenderFns } from "./application-form.vue?vue&type=template&id=f356645c&scoped=true&"
import script from "./application-form.vue?vue&type=script&lang=js&"
export * from "./application-form.vue?vue&type=script&lang=js&"
import style0 from "./application-form.vue?vue&type=style&index=0&id=f356645c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f356645c",
  null
  
)

export default component.exports